import {observable, computed, autorun, extendObservable} from 'mobx';
import moment from 'moment';
import {BMC_BLOCKS} from '../../common_components/bmc/bmc_constants';
import {LEAN_BLOCKS} from '../constants.js';
import uuid from 'node-uuid';
import {blocksArray} from '../../common_components/bmc/bmc_functions';


export default class ActivityModel {
    store;
    id;
    

    constructor(store, id) {
        this.store = store;

        extendObservable(this, {
            // Temporal edition (To be removed)
            detailsEdit: "",
            costDescriptionEdit: "",
            costValueEdit: 0,
            preselectedCardId: "",

            id: id,
            selectedCardsInfo: [], //{card_id, block, details}
            place: "",
            description: "",
            name:"",
            status:"todo",
            startDate: moment(),
            finishDate: moment(), 
            _costs: [],
            leanDetails: { 
                measure: [],
                learn: [],
                build: [],
            },
        });
    }

    destroy(){
        this.store.destroyActivity(this.id);
        this.store.activities.remove(this);
    }

    copy(activity){
        this.place = activity.place;
        this.description = activity.description;
        this.name = activity.name;
        this.copyCards(activity);
        this.copyCosts(activity);
        this.copyLeanDetails(activity);
    }

    copyCards(activity){
        for( let block of blocksArray() ){
            let cards = activity.getSelectedCardsByBlock(block);
            for( let card of cards ){
                this.detailsEdit = activity.getDetails(card.id);
                this.addCard(card, block);
            }
        }
    }

    copyCosts(activity){
        for(let cost of activity.costs ){
            this.costDescriptionEdit = cost.description;
            this.costValueEdit = cost.value;
            this.addCost();
        }
    }

    copyLeanDetails(activity){
        const blocks = Object.values(LEAN_BLOCKS);
        for( let leanBlock of blocks){
            let items = activity.leanDetails[leanBlock];
            for( let item of items ){
                this.addLeanDetails(leanBlock, item.description)
            }
        }
    }

    serialize(){
        const activityCosts = this._costs.map((el) => ({id: !el.temporaryId && el.id, description: el.description, value: el.value, _destroy: el.destroy}) )
        const cardsAttributes = this.selectedCardsInfo.map((el) => ({id: !el.temporaryId && el.id, bmc_card_id: el.card_id, details: el.details, _destroy: el.destroy}));
        const measure = this.leanDetails[LEAN_BLOCKS.MEASURE].map( (el) => ({id: !el.temporaryId && el.id, description: el.description, _destroy: el.destroy}));
        const learn = this.leanDetails[LEAN_BLOCKS.LEARN].map( (el) => ({id: !el.temporaryId && el.id, description: el.description, _destroy: el.destroy}));
        const build = this.leanDetails[LEAN_BLOCKS.BUILD].map( (el) => ({id: !el.temporaryId && el.id, description: el.description, _destroy: el.destroy}));
        const newActivity = {
            id: this.id,
            name: this.name,
            description: this.customDescription, 
            start_date: this.startDate,
            finish_date: this.finishDate,
            place: this.place,
            costs_attributes: activityCosts, 
            activities_bmc_cards_attributes: cardsAttributes,   
            measures_attributes: measure,
            learns_attributes: learn,
            builds_attributes: build
        }
        return newActivity;
    }

    deserialize(json){
        const activityCosts = json.costs.map((el) => ({id: el.id, description: el.description, value: el.value, destroy: false}) )
        const selectedCardsInfo = json.activities_bmc_cards.map((el) => ({id: el.id, card_id: el.bmc_card_id, details: el.details, block: el.block, destroy: false}));
        const measure = json.measures.map( (el) => ({id: el.id, description: el.description, destroy: false}));
        const learn = json.learns.map( (el) => ({id: el.id, description: el.description, destroy: false}));
        const build = json.builds.map( (el) => ({id: el.id, description: el.description, destroy: false}));
        this.id = json.id;
        this.description = json.description;
        this.place = json.place;
        this.startDate = moment(json.start_date);
        this.finishDate = moment(json.finish_date);
        this.status = json.status;
        this.name = json.name;
        this.leanDetails[LEAN_BLOCKS.MEASURE] = measure;
        this.leanDetails[LEAN_BLOCKS.BUILD] = build;
        this.leanDetails[LEAN_BLOCKS.LEARN] = learn;
        this._costs = activityCosts;
        this.selectedCardsInfo = selectedCardsInfo;
    }


    @computed get activityName(){
        const card = this.getSelectedCardsByBlock(BMC_BLOCKS.KEY_ACTIVITIES)[0]; 
        return card && card.name;
    }

    @computed get activityDescription(){
        const card = this.getSelectedCardsByBlock(BMC_BLOCKS.KEY_ACTIVITIES)[0];  
        return card && card.description;
    }

    @computed get customDescription(){
        return this.description;
    }

    @computed get goals(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.REVENUE_STREAMS);
    }

    @computed get offers(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.KEY_PROPOSITIONS);
    }

    @computed get customers(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.CUSTOMER_SEGMENTS);
    }

    @computed get invitation(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.CUSTOMER_RELATIONSHIPS);
    }

    @computed get connection(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.CHANNELS);
    }

    @computed get resources(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.KEY_RESOURCES);
    }

    @computed get partners(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.KEY_PARTNERS);
    }

    @computed get costStructure(){
        return this.getSelectedCardsByBlock(BMC_BLOCKS.COST_STRUCTURE);
    }

    @observable getDetails(cardId){
        return this.getCardInfo(cardId).details;
    }

    @computed get costs(){
        return this._costs.filter( (el) => !el.destroy );
    }

    @computed get measure(){
        return this.leanDetails[LEAN_BLOCKS.MEASURE].filter((el) => !el.destroy);
    }

    @computed get learn(){
        return this.leanDetails[LEAN_BLOCKS.LEARN].filter((el) => !el.destroy);;
    }

    @computed get build(){
        return this.leanDetails[LEAN_BLOCKS.BUILD].filter((el) => !el.destroy);;
    }

    @observable getLeanBlockElements(block){
        switch(block){
            case LEAN_BLOCKS.MEASURE:
                return this.measure;
                break;
            case LEAN_BLOCKS.LEARN:
                return this.learn;
                break;
            case LEAN_BLOCKS.BUILD:
                return this.build;
                break;
        }

        return [];
    }

    @observable getSelectedCardsByBlock(block){
        const cardsIds = this.selectedCardsInfo.filter((el) => (el.block == block) && !el.destroy ).map((el) => el.card_id);
        const cards = this.store.rootStore.igBusinessStore.getCardsFromIdsArray(cardsIds);
        return cards;
    }

    @observable
    getAllSelectedCards(){
        const blocks = blocksArray();
        let cards = []
        for(let block of blocks ){
            cards = [...cards, ...this.getSelectedCardsByBlock(block)]
        }
        return cards;
    }

    @observable getSelectedCardsCountByBlock(block){
        const count = this.selectedCardsInfo.filter((el) => (el.block == block && !el.destroy) ).length;
        return count;
    }

    @computed get preselectedCard(){
        if( this.preselectedCardId ){
            return this.store.rootStore.igBusinessStore.getCardsFromIdsArray([this.preselectedCardId])[0]
        }
        return undefined;
    }

    @computed get preselectedCardDetails(){
        let cardInfo = this.preselectedCardInfo;
        if( cardInfo ){
            return cardInfo.details;
        }
    }

    @computed get preselectedCardInfo(){
        return this.getCardInfo(this.preselectedCardId);
    }



    getCardInfo(cardId){
        return this.selectedCardsInfo.find((el) => (el.card_id == cardId) && !el.destroy );
    }

    setPreselectedCard(card){
        if( card ){
            this.preselectedCardId = card.id;
        }
        else{
            this.preselectedCardId = undefined;
        }
        
    }

    addCard(card, block){
        if( block == BMC_BLOCKS.KEY_ACTIVITIES ){
            let card = this.removeCard(this.getSelectedCardsByBlock(block)[0]); 
        }
        let selectedCard = { id: null, temporaryId: true, destroy: false, card_id: card.id, block: block, details: this.detailsEdit }
        this.selectedCardsInfo.push(selectedCard);
        card.selected = true;
    }

    resetAdditionalInformation(){
        this.name = "",
        this.description = "",
        this.place = "";
        this.startDate = moment();
        this.finishDate = moment();
    }

    removeCard(card, block=null){
        if( card ){
            const index = this.selectedCardsInfo.findIndex((el) => (el.card_id == card.id) && !el.destroy );
            if( index > -1 ){
                let cardInfo = this.selectedCardsInfo[index];
                // Not persisted yet in the backend, just remove it from the array. 
                if( cardInfo.temporaryId ){
                    this.selectedCardsInfo.splice(index, 1);    
                }
                // Mark to be destroyed in backend
                else{
                    this.selectedCardsInfo[index].destroy = true;                    
                }
            }   
            card.preselected = false;
            card.selected = false;
        }
        if( block == BMC_BLOCKS.KEY_ACTIVITIES){
            this.resetAdditionalInformation();
        }
    }

    @observable
    isSelected(card){
        return this.selectedCardsInfo.findIndex( (c) => (c.card_id == card.id) && !c.destroy) > -1;
    }

    handleDetailsChange(value, cardId){
        let cardInfo = this.getCardInfo(cardId);
        if( cardInfo ){
            cardInfo.details = value;
        }
        else{
            this.detailsEdit = value;   
        }
    }

    handlePlaceChange(value){
        this.place = value;
    }

    handleNameChange(value){
        this.name = value;
    }

    handleDescriptionChange(value){
        this.description = value;
    }

    handleStartDateChange(date){
        this.startDate = date;
    }

    handleFinishDateChange(date){
        this.finishDate = date;
    }

    validateDates(date){
        if( this.startDate <= this.finishDate ){
            return "success";
        }
        return "error"
    }

    handleCostDescriptionChange(value){
        this.costDescriptionEdit = value;
    }

    handleCostValueChange(value){
        this.costValueEdit = value;
    }

    addCost(){
        let id = uuid.v4();
        let cost = {id: id, temporaryId: true, destroy: false, description: this.costDescriptionEdit, value: this.costValueEdit };
        this.costDescriptionEdit = "";
        this.costValueEdit = ""; 
        this._costs.push(cost);
    }

    removeCost(id){   
        let index = this._costs.findIndex( (el) => el.id == id );
        if( index > -1 ){
            let cost = this._costs[index];
            // If not pesisted yet in backend just remove it from the array
            if( cost.temporaryId ){
                this._costs.splice(index, 1);                
            }
            // Else, mark for destroy in backend 
            else{
                cost.destroy = true;
            }
        }
    }

    addLeanDetails(block, text){
        let id = uuid.v4();
        this.leanDetails[block].push({ id: id, temporaryId: true, description: text, destroy: false });
    }

    removeLeanElement(block, id){
        let index = this.leanDetails[block].findIndex( (el) => el.id == id );
        if( index > -1 ){
            let element = this.leanDetails[block][index];
            // If not pesisted yet in backend just remove it from the array
            if( element.temporaryId ){
                this.leanDetails[block].splice(index, 1);
            }
            // Else, mark for destroy in backend 
            else{
                element.destroy = true;
            }
        }
        
    }

}